import { NgModule } from '@angular/core';
import { PaymentLinkLandingContainerComponent } from './components/payment-link-landing/payment-link-landing-container.component';
import { PaymentLinkErrorComponent } from './components/payment-link-error/payment-link-error.component';
import { PaymentLinkExpiredComponent } from './components/payment-link-expired/payment-link-expired.component';
import { EffectsModule } from '@ngrx/effects';
import {
  PaymentLinkLandingComponentEffects,
  PaymentLinkLandingComponentPaymentLinkEffects,
  PaymentLinkLandingComponentPermissionEffects,
} from './components';
import { PaymentLinksRoutingModule } from './payment-links-routing.module';
import { SharedPaymentModule } from '@arc/unified-payments-frontend/shared-payment';
import { LazyModuleLanguageChangeEffects } from '@arc/unified-payments-frontend/i18n';
import { StoreModule } from '@ngrx/store';
import { paymentLinksFeature } from './store/reducers';

@NgModule({
  declarations: [
    PaymentLinkLandingContainerComponent,
    PaymentLinkErrorComponent,
    PaymentLinkExpiredComponent,
  ],
  imports: [
    SharedPaymentModule,
    PaymentLinksRoutingModule,
    StoreModule.forFeature(paymentLinksFeature),
    EffectsModule.forFeature([
      LazyModuleLanguageChangeEffects,
      PaymentLinkLandingComponentEffects,
      PaymentLinkLandingComponentPaymentLinkEffects,
      PaymentLinkLandingComponentPermissionEffects,
    ]),
  ],
  exports: [],
})
export class PaymentLinksModule {}
